import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/admin/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";
import { formatDateTime } from "@/lib/format";

export default function AdminInbox() {
  const [contacts, setContacts] = useState(null);
  const [partners, setPartners] = useState(null);
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => setContacts(r.data)).catch(() => setContacts([]));
    api.get("/admin/partners").then((r) => setPartners(r.data)).catch(() => setPartners([]));
    api.get("/admin/newsletter").then((r) => setSubs(r.data)).catch(() => setSubs([]));
  }, []);

  return (
    <div>
      <PageHeader title="Contacts & leads" subtitle="Contact form submissions, partnership requests and newsletter subscribers" />
      <Tabs defaultValue="contacts">
        <TabsList><TabsTrigger value="contacts">Contact ({contacts?.length ?? 0})</TabsTrigger><TabsTrigger value="partners">Partners ({partners?.length ?? 0})</TabsTrigger><TabsTrigger value="newsletter">Newsletter ({subs?.length ?? 0})</TabsTrigger></TabsList>

        <TabsContent value="contacts" className="mt-5">
          <Panel data={contacts} empty="No contact submissions yet." render={(c) => (
            <div key={c.id} className="bg-white rounded-xl border border-border p-5" data-testid={`contact-${c.id}`}>
              <div className="flex justify-between"><p className="font-semibold text-[#111827]">{c.full_name}</p><span className="text-xs px-2 py-0.5 rounded-full bg-muted">{c.enquiry_type}</span></div>
              <p className="text-sm text-muted-foreground">{c.email} · {c.phone}</p>
              {c.subject && <p className="mt-2 text-sm font-medium text-[#111827]">{c.subject}</p>}
              <p className="mt-1 text-sm text-muted-foreground">{c.message}</p>
              <p className="mt-2 text-xs text-muted-foreground">{formatDateTime(c.created_at)}</p>
            </div>
          )} />
        </TabsContent>
        <TabsContent value="partners" className="mt-5">
          <Panel data={partners} empty="No partnership requests yet." render={(p) => (
            <div key={p.id} className="bg-white rounded-xl border border-border p-5" data-testid={`partner-${p.id}`}>
              <div className="flex justify-between"><p className="font-semibold text-[#111827]">{p.company_name}</p><span className="text-xs px-2 py-0.5 rounded-full bg-muted">{p.partner_type}</span></div>
              <p className="text-sm text-muted-foreground">{p.contact_name} · {p.email} · {p.phone}</p>
              {p.message && <p className="mt-1 text-sm text-muted-foreground">{p.message}</p>}
              <p className="mt-2 text-xs text-muted-foreground">{formatDateTime(p.created_at)}</p>
            </div>
          )} />
        </TabsContent>
        <TabsContent value="newsletter" className="mt-5">
          {subs === null ? <Loader /> : subs.length === 0 ? <Empty text="No subscribers yet." /> : (
            <div className="bg-white rounded-xl border border-border divide-y divide-border">
              {subs.map((s) => <div key={s.id} className="flex justify-between p-4 text-sm" data-testid={`sub-${s.id}`}><span className="text-[#111827]">{s.email}</span><span className="text-muted-foreground">{formatDateTime(s.created_at)}</span></div>)}
            </div>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
function Loader() { return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-[#C81D35] animate-spin" /></div>; }
function Empty({ text }) { return <div className="text-center py-16 bg-white rounded-xl border border-border text-muted-foreground">{text}</div>; }
function Panel({ data, empty, render }) { if (data === null) return <Loader />; if (data.length === 0) return <Empty text={empty} />; return <div className="grid gap-4">{data.map(render)}</div>; }
